import { LegendModel } from '../../models/legend.model'

export const roadCoverageLegend: LegendModel = {
  type: 'static',
  items: [
    {
      description: '>0',
      value: 'road-coverage-0', // near white
    },
    {
      description: '>5',
      value: 'road-coverage-5',
    },
    {
      description: '>7',
      value: 'road-coverage-7',
    },
    {
      description: '>10',
      value: 'road-coverage-10',
    },
    {
      description: '>20',
      value: 'road-coverage-20',
    },
    {
      description: '>100',
      value: 'road-coverage-100',
    },
  ],
}
